<template>
  <div>
    <div class="row">
      <div @click="PetSelected(pet)" :class="{'active':(pet==selectedPet)}" class="col-md-4 col-xs-6 pet-list padding_right_10 padding_left_10" v-for="(pet, index) in pets" v-bind:key="index">
        <PetListItem :PetDetails="pet" />
      </div>
    </div>
    <div class="row text-center" style="padding-top:30px;">
      <div class="col-md-12 col-sm-12 col-xs-12 ">
        <div style="font-size:14px;">OR</div>
      </div>
    </div>
    <div class="row text-center" style="padding-top:30px;">
      <div class="col-md-12 col-sm-12 col-xs-12 ">
        <button class="btn btn__primary__cta" @click="MoveToNewPetForm()">
          Add new Pet
        </button>
      </div>
    </div>
    <div class="row margin__top__40 margin__bottom__20" style="padding-bottom:60px;">
      <div class="col-md-6 col-sm-6 col-xs-6">
        <button class="btn btn__secondary" @click="goBack()">Previous</button>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6">
        <button class="btn btn-lg btn__primary pull-right" v-if="selectedPet!=null" @click="MoveToNextPage()">
          <div>Next</div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PetListItem from '../components/PetListItem'

export default {
  name: 'PetList',
  components: { PetListItem },
  computed: {
    ...mapGetters({
      pets: 'pets',
      petOwnerDetails: 'petOwnerDetails',
      selectedPet: 'selectedPet'
    })
  },
  created() {
    if (this.petOwnerDetails && this.petOwnerDetails.FirstName == '') {
      this.$router.replace({ name: 'PetOwnerDetails' })
    }
    this.$store.dispatch('SetPageNumber', 3);
  },

  methods: {
    PetSelected: function (pet) {
      this.$store.dispatch('SetSelectedPet', pet);
      this.$store.dispatch('InitializeDueVaccine', pet);
      this.$router.push({ name: 'PetServices' })
    },
    MoveToNextPage: function () {
      this.$router.push({ name: 'PetServices' })
    },
    MoveToNewPetForm: function () {
      this.$store.dispatch('ResetSelectedPet');
      this.$router.replace({ name: 'NewPet' })
    },
    goBack: function () {
      this.$router.replace({ name: 'PetOwnerDetails' })
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/PetList.vue